// extracted by mini-css-extract-plugin
module.exports = {"container":"Leaderboard_container__2JclS","oldContainer":"Leaderboard_oldContainer__pxrs8","leaderboard":"Leaderboard_leaderboard__5X5XE","mvMobile":"Leaderboard_mvMobile__auVec"};